import { sortByName, sortByCountDesc } from '../helpers/sorters';

export const baseAlgoliaConfig = {
  APPLICATION_ID: '7FI9T0IXZ5',
  HITS_PER_PAGE: 10,
  MAX_VALUES_PER_FACET: 30,
  SEARCH_ONLY_API_KEY: 'b998ea87dc6edcbdf733d2796f8eccf7'
};

export const baseFacetConfig = {
  disjunctive: true,
  topListIfRefined: false
};

export const watched = {
  guides: {
    INDEX_NAME: 'vol-resources2019-06-04T21:47:40.216Z',
    FACET_CONFIG: [
      {
        name: 'fragments.resource.resourceTopics.value.fragments.topic.value',
        sortFunction: sortByName,
        title: 'Topics'
      },
      {
        name: 'fragments.resource.resourceType.value',
        sortFunction: sortByCountDesc,
        title: 'Type'
      }
    ]
  },
  marketplace: {
    INDEX_NAME: 'vol-apps2019-06-04T21:47:36.858Z',
    FACET_CONFIG: [
      {
        name: 'fragments.app.appCategories.value.fragments.catgory.value',
        sortFunction: sortByName,
        title: 'Categories'
      },
      {
        name: 'fragments.app.appIsFree.value',
        sortFunction: sortByCountDesc,
        title: 'Price'
      },
      {
        name: 'fragments.app.appIsFeatured.value.fragments.attribute.value',
        sortFunction: sortByCountDesc,
        title: 'Extras'
      }
    ]
  },
  experts: {
    INDEX_NAME: 'undefined',
    FACET_CONFIG: [
      {
        name: 'fragments.expert.expertServices.value.fragments.catgory.value',
        sortFunction: sortByName,
        title: 'Services'
      },
      {
        name: 'fragments.expert.expertCountriesServed.value.fragments.country.value',
        sortFunction: sortByName,
        title: 'Region'
      },
      {
        name: 'fragments.expert.expertLevel.value',
        sortFunction: sortByCountDesc,
        title: 'Level'
      }
    ]
  }
};
